// LiveDigital/LiveDigitalRoom.tsx
import React, {useEffect, useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import {useTheme} from 'Theme/ThemeContext';
import {IConsultation} from 'Types/psychology/consultation';

interface LiveDigitalRoomProps {
    consultation: IConsultation;
}

const LiveDigitalRoom: React.FC<LiveDigitalRoomProps> = ({consultation}) => {
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const navigate = useNavigate();
    const {plt, theme, themeLoading} = useTheme();

    // Используем имя комнаты из объекта conference
    const roomName = consultation.conference?.name || '';

    useEffect(() => {
        if (themeLoading) {
            console.log('Загрузка темы...');
            return;
        }
        if (!iframeRef.current) return;

        // Пример: если нужно передать тему в iframe, можно отправить сообщение после загрузки
        const handleIframeLoad = () => {
            if (iframeRef.current?.contentWindow) {
                const themeData = {
                    accent: plt.colors.primary.main,
                    background: plt.bg.primary,
                    text: plt.text.primary,
                };
                // Отправляем данные темы в iframe через postMessage (при условии, что LiveDigital умеет их принимать)
                iframeRef.current.contentWindow.postMessage({type: 'setTheme', data: themeData}, '*');
            }
        };

        iframeRef.current.addEventListener('load', handleIframeLoad);

        // Обработчик сообщений от iframe
        const handleMessage = (event: MessageEvent) => {
            // Можно проверить event.origin для безопасности
            if (event.data === 'left-meeting') {
                console.log('Пользователь покинул комнату');
                navigate(`/consultations?for_feedback=${roomName.split('_').pop()}`);
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            iframeRef.current?.removeEventListener('load', handleIframeLoad);
            window.removeEventListener('message', handleMessage);
        };
    }, [roomName, navigate, plt, themeLoading]);

    return (
        !themeLoading && (
            <div className="fc h-100" style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <iframe
                    ref={iframeRef}
                    title="LiveDigital Room"
                    src={`https://edu.livedigital.space/room/${consultation.conference?.room_id}`}
                    style={{width: '100%', height: '100%', border: 'none'}}
                    allow="camera;microphone;fullscreen;accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;display-capture;"
                />
            </div>
        )
    );
};

export default LiveDigitalRoom;
